import React, { FunctionComponent } from 'react'
import { MarkdownRemark } from '@/graphql-types'
import { Link } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import classnames from 'classnames'
import { Card } from '../card'
import moment from 'moment'

const Styles = require('./postItem.module.styl')

type Props = {
  node: MarkdownRemark
  path?: string
  className?: string
}

export const PostItem: FunctionComponent<Props> = ({ node, className, path }) => {
  return (
    <Card cardCls={ Styles['card'] }>
      <Link to={path ?? ''}>
        <div className={classnames(Styles['post'], className)}>
          <div className={Styles['content']}>
            <div className={Styles['header']}>
              <span className={Styles['title']}>{node.frontmatter?.title || node.fields?.slug}</span>
              {/* <div className={Styles['line']} /> */}
            </div>
            <div className={Styles['brief']}>
              <ReactMarkdown source={node.frontmatter?.description ?? node.excerpt!} />
            </div>
            <div className={Styles['info']}>
              {node.frontmatter?.tags?.map(tag => (
                <React.Fragment key={tag}>
                  <i className='iconfont'>&#xe63e;</i>
                  <Link to='/tags' className={Styles['tag']}>
                    {tag}
                  </Link>
                  <span className={Styles['line']}>·</span>
                </React.Fragment>
              ))}
              {node?.timeToRead ?? 0 + 1} min read
              <span className={Styles['time']}>
                <span className={Styles['line']}>·</span>
                {moment(node.frontmatter?.date).fromNow()}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  )
}
